import { render, staticRenderFns } from "./CustomerLeadDetail.vue?vue&type=template&id=4ee9b016&scoped=true&"
import script from "./CustomerLeadDetail.vue?vue&type=script&lang=js&"
export * from "./CustomerLeadDetail.vue?vue&type=script&lang=js&"
import style0 from "./CustomerLeadDetail.vue?vue&type=style&index=0&id=4ee9b016&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee9b016",
  null
  
)

export default component.exports